import {TranslationKey, TranslationStringParamMap} from 'notability-services-common-universal'
import React from 'react'
import {Trans} from 'react-i18next'
import {TranslationComponentParamMap} from './frontendTranslationTypes'

export interface TranslateProps<K extends TranslationKey> {
  /** Key for translation as defined in en.json.  Run `bun run translate` if giving type error. */
  i18nKey: K

  /** Children of the node.  Implicitly set by giving the tag children. */
  children?: React.ReactNode

  /** Values to be interpolated into the translation string. */
  values?: TranslationStringParamMap[K]

  /** components to wrap translated strings surrounded by component tags. */
  components?: TranslationComponentParamMap[K]

  /** See https://react.i18next.com/latest/trans-component#trans-props Unescapes HTML-encoded tags */
  shouldUnescape?: boolean
}

/**
 * Translate a component with structured children.
 * @see https://react.i18next.com/latest/trans-component
 */
export function GLTranslate<K extends TranslationKey>(props: TranslateProps<K>) {
  return (
    // Casting the i18nKey as string as typescript complains that the union of all the translation values is too large to represent. May be worth looking into new ways to represent this?
    <Trans
      i18nKey={props.i18nKey as string}
      components={props.components}
      values={props.values}
      shouldUnescape={props.shouldUnescape}
    >
      {props.children}
    </Trans>
  )
}
